import moment from "../../../moment";

// 払い戻し、譲渡ボタンなどの表示時に有効期間内かを判別
// service層内での使用のみで、Viewからは使用しない
export const checkIsValidPeriod = (book) => {
  const limit = book.available_limited_at;
  const now = moment(new Date());
  return now.isBefore(limit) ? true : false;
};
